@if (isOpen()) {
  <div
    class="fixed z-10 top-0 left-0 text-white"
    animate.enter="fly-in"
    animate.leave="fly-out"
  >
    <div class="bg-gray-800 rounded-b-[2.5rem] h-[calc(100vh+8rem)] w-dvw pb-[calc(1.5rem+2rem+5.5rem)]">
      <div class="flex flex-col w-full h-full py-4 px-3 md:px-6">
        <div class="flex justify-between">
          <div
            routerLink="/"
            class="relative flex place-items-center cursor-pointer"
          >
            <ticketing-combined-logo
              class="block h-10 md:h-12"
              [appearance]="'light'"
            />
          </div>
        </div>

        <div class="h-16"></div>
        <div class="my-5 px-3 flex-grow flex flex-col">
          <div class="mt-0">
            @for (item of navItems(); track item.name) {
              <div
                routerLink="{{ item.path }}"
                class="menu-item"
              >
                {{ item.name }}
              </div>
            }
          </div>
          <ticketing-button
            class="mt-10"
            appearance="white"
            routerLink="/profile"
          >
            <div class="flex text-xl place-items-center">
              <span>Zu den Losungen</span>
              <fa-icon
                class="ml-2"
                size="lg"
                [icon]="faTicket"
              />
            </div>
          </ticketing-button>
        </div>
      </div>
    </div>
  </div>
}
